import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Chip,
  Stack,
  Typography,
  Divider
} from '@mui/material';
import { useClientZS } from '../../../pages/ClientZS';

export const PaymentsCard = () => {
  const { orderData, paid, advanceLeftToPay } = useClientZS();

  const paymentState =
    orderData.left_to_pay === 0
      ? 'Zapłacono'
      : orderData.sum_of_advances > 0 && advanceLeftToPay > 0 ? 'Zaliczka częściowo opłacona'
        : advanceLeftToPay == 0
          ? 'Zaliczka opłacona'
          : 'Do zapłaty';

  const paymentColor =
    orderData.left_to_pay === 0
      ? 'success'
      : orderData.sum_of_advances > 0
        ? 'warning'
        : 'error';

  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: theme => theme.shadows[2]
      }}
    >
      <CardContent sx={{ p: 5 }}>
        <Typography
          variant="h5"
          fontWeight={700}
          mb={3}
        >
          Płatności
        </Typography>

        <Chip
          color={paymentColor}
          label={paymentState}
          sx={{ mb: 4 }}
        />

        <Stack spacing={4}>
          <Box>
            <Typography color="text.secondary">
              Wartość zamówienia
            </Typography>

            <Typography
              variant="h4"
              fontWeight={700}
            >
              {orderData.order_value} zł
            </Typography>
          </Box>

          <Box>
            <Typography color="text.secondary">
              Zapłacono
            </Typography>

            <Typography
              variant="h4"
              fontWeight={700}
            >
              {paid} zł
            </Typography>
          </Box>

          <Box>
            <Typography color="text.secondary">
              Pozostała zaliczka do zapłaty
            </Typography>

            <Typography
              variant="h4"
              fontWeight={700}
              color={advanceLeftToPay > 0 ? 'error.main' : 'success.main'}
            >
              {advanceLeftToPay.toFixed(2)} zł
            </Typography>
          </Box>

          <Divider />

          <Box>
            <Typography color="text.secondary">
              Pozostało do zapłaty
            </Typography>

            <Typography
              variant="h3"
              fontWeight={700}
              color={
                orderData.left_to_pay > 0
                  ? 'error.main'
                  : 'success.main'
              }
            >
              {orderData.left_to_pay} zł
            </Typography>
          </Box>
        </Stack>
      </CardContent>
    </Card>

  );
};
